import { render, staticRenderFns } from "./scopeDetail.vue?vue&type=template&id=7998a8d3&scoped=true&"
import script from "./scopeDetail.vue?vue&type=script&lang=js&"
export * from "./scopeDetail.vue?vue&type=script&lang=js&"
import style0 from "./scopeDetail.vue?vue&type=style&index=0&id=7998a8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7998a8d3",
  null
  
)

export default component.exports